import { ContractRequestPageLoad, HomePageLoad, SearchContractPageLoad, SecurityPageLoad } from '@/modules/home/pages';

export default {
  ContractRequest: {
    exact: true,
    path: '/contract-request',
    component: ContractRequestPageLoad
  },
  Home: {
    exact: true,
    path: ['/'],
    component: HomePageLoad
  },
  Search: {
    exact: true,
    path: ['/search'],
    component: SearchContractPageLoad
  },
  default: {
    exact: false,
    component: SecurityPageLoad
  },
};
